// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".page-lesson{margin-bottom:12rem}table tr td{font-size:16px;vertical-align:baseline}table tr td:first-child{word-break:keep-all}table tr td:nth-child(2){text-align:right}span.trainer:not(:last-of-type):after{content:\", \"}.course-information{margin-top:2rem}.course-information ul{padding-left:1.25rem}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
